export const withparamsModelHTMLStringModel = (type, formattedOptions) => {
  return type === "model" && formattedOptions.length
    ? ` <span class="atn">data-options</span><span class="pun">=</span><span class="atv">"${formattedOptions.trim()}"</span>`
    : "";
};
